<template>
  <div>
    <div
      class="skeleton"
      :style="{width: width}"
    >
      <div class="lines">
        <div
          class="thumb pulse"
          :style="{height: height}">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: String,
    height: String
  }
}
</script>

<style lang="scss" scoped>
.skeleton {
  .pulse {
    $from: #f5f5f5;
    $to: scale-color($from, $lightness: -10%);

    background: linear-gradient(
      -90deg,
      #efefef 0%,
      #fcfcfc 50%,
      #efefef 100%
    );

    background-size: 400% 400%;
    animation: pulse 1.2s ease-in-out infinite;

    @keyframes pulse {
      0% {
        background-position: 0% 0%;
      }
      100% {
        background-position: -135% 0%;
      }
    }
  }

  .lines {
    .line, .thumb {
      background-color: #f5f5f5;
    }
  }
}
</style>
